
import { defineComponent } from 'vue';
import {
    AppFormRow,
    AppCard,
    AppButton,
    AppSwitch,
    AppSelect,
    AppFileUpload,
    AppImageHolder,
    AppAvatarBreadcrumb
} from '@/components';
import { useAvatarImageEdit } from '@/modules/avatar/item/image/model/edit';
import { ROUTE_NAME_AVATAR } from '@/modules/avatar/router';

export default defineComponent({
    name: ROUTE_NAME_AVATAR.ITEM.IMAGE.EDIT,
    components: {
        AppFormRow,
        AppCard,
        AppButton,
        AppSwitch,
        AppSelect,
        AppFileUpload,
        AppImageHolder,
        AppAvatarBreadcrumb
    },
    setup() {
        const { model, colorOption, layerOption, actions } = useAvatarImageEdit();

        return { model, colorOption, layerOption, actions };
    }
});
